import { render, staticRenderFns } from "./DocumentsAdminManagers.vue?vue&type=template&id=79fff1d8&scoped=true"
import script from "./DocumentsAdminManagers.vue?vue&type=script&lang=ts"
export * from "./DocumentsAdminManagers.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsAdminManagers.vue?vue&type=style&index=0&id=79fff1d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fff1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fff1d8')) {
      api.createRecord('79fff1d8', component.options)
    } else {
      api.reload('79fff1d8', component.options)
    }
    module.hot.accept("./DocumentsAdminManagers.vue?vue&type=template&id=79fff1d8&scoped=true", function () {
      api.rerender('79fff1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/admin/DocumentsAdminManagers.vue"
export default component.exports